ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}
ProductReviews.Templates ?= {}

ProductReviews.Views.AddReview = Backbone.View.extend
  el: '#product-reviews-add-pane'
  touch:
    productReviewsPane: '#product-reviews-pane'
    dealData: '.deal-data'
    starRating: '#add-review-rating'
    ratingHint: '#rating-hint'
    addReviewText: '#add-review-text'
    addUserReviewButton: '#product-reviews-add-review'
    addReviewNotification: '#add-review-notification'
    submitReviewButton: '#submit-review'
  events:
    'click .t-back-link': 'hideAddReviewPane'
    'click #add-review-rating ul li': 'addUserRating'
    'click #submit-review': 'submitUserReview'

  initialize: ->
    @$el ?= $(@el)
    _.extend this, @options
    @$productReviewsPane = $(@touch.productReviewsPane)
    @$dealData = $(@touch.dealData)
    @$starRating = $(@touch.starRating)
    @$ratingHint = $(@touch.ratingHint)
    @$addReviewText = $(@touch.addReviewText)
    @$addUserReviewButton = $(@touch.addUserReviewButton)
    @$addReviewNotification = $(@touch.addReviewNotification)
    @$submitReviewButton = $(@touch.submitReviewButton)

  addUserRating: (e) ->
    @$selectedRating = $(e.currentTarget).children()
    rating = @$selectedRating.data('star-rating')
    for x in [1..5]
      star = $("#review-star-#{x}")
      if x <= rating then star.removeClass('empty-star').addClass('selected-star') else star.addClass('empty-star').removeClass('selected-star')
    @$ratingHint.text "#{I18n.t "js.modules.product_reviews.review_form.rating_description.rating_#{rating}"}"
    @showReviewText()

  showReviewText: ->
    @$starRating.addClass 'move-up'
    @$ratingHint.addClass 'move-up'
    @$addReviewNotification.addClass 'move-up'
    @$addReviewText.addClass 'fadein move-up'
    @$dealData.addClass 'fadeout'

  hideAddReviewPane: ->
    @$el.hide()
    @$productReviewsPane.show()

  submitUserReview: ->
    return unless @$selectedRating
    @addReviewModel.set 'rating', @$selectedRating.data('star-rating')
    @addReviewModel.set 'text', @$addReviewText.children('textarea').val()
    @$submitReviewButton.prop('disabled', true)
    @addReviewModel.review()

  showReviewSuccess: (userReview) ->
    userReview.render()
    @$addUserReviewButton.addClass 'review-submitted success'
    @$addUserReviewButton.text I18n.t 'js.modules.product_reviews.create_review.success'
    userReview.model.view = @productReviewsView
    @productReviewsView.userReviewModel = userReview.model
    @hideAddReviewPane()

  showReviewError: ->
    @$submitReviewButton.prop('disabled', false)
    @$addReviewNotification.addClass 'review-submitted error'
    @$addReviewNotification.text I18n.t 'js.modules.product_reviews.create_review.error'


module.exports = ProductReviews.Views.AddReview
